"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DmsDragAndDropTags = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDraggable = _interopRequireDefault(require("react-draggable"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * DmsDragAndDropTags Component
 * 
 * This component enables drag-and-drop functionality for its children elements.
 * It uses the `react-draggable` library to allow horizontal dragging within the container.
 * 
 * Props:
 * - `handleClassName` (string): CSS class name for the drag handle. Default is 'handle'.
 * - `onStart` (function): Callback function triggered when dragging starts.
 * - `onDrag` (function): Callback function triggered while dragging is in progress.
 * - `onStop` (function): Callback function triggered when dragging stops.
 * - `children` (ReactNode): The content to be made draggable within the component.
 * 
 * Example usage:
 * 
 * 
 * <DmsDragAndDropTags>
 *     <DmsButton variant='primary' text='Button' />
 * </DmsDragAndDropTags>
 * 
 */
const DmsDragAndDropTags = _ref => {
  let {
    handleClassName = 'handle',
    onStart,
    onDrag,
    onStop,
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_reactDraggable.default, {
    axis: "x",
    handle: ".".concat(handleClassName),
    defaultPosition: {
      x: 0,
      y: 0
    },
    position: null,
    grid: [25, 25],
    scale: 1,
    onStart: onStart,
    onDrag: onDrag,
    onStop: onStop
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: handleClassName,
    style: {
      cursor: 'move'
    }
  }, "Drag from here"), /*#__PURE__*/_react.default.createElement("div", null, children)));
};
exports.DmsDragAndDropTags = DmsDragAndDropTags;
var _default = exports.default = DmsDragAndDropTags;